import React from 'react'
import filter_color from "../../assets/images/design/colorFilter.svg"
import eudcc from "../../assets/images/contents/eudcc-whitepaper.gif"
import { PrimaryButton, PrimaryButton2th } from '../../components/StyledButtons'
import WhitepaperDownloadForm from './WhitepaperDownloadForm'
import OtherWhitepapers from './OtherWhitepapers'
import hr_document from "../../assets/images/contents/hr-document-security.png"
import info_graphic from "../../assets/images/contents/info-graphic.png"
import document_security_2023 from "../../assets/images/contents/document-security.png"
import Navbar from '../../components/Navbar'
import IndustriesImageContainer from '../../components/IndustriesImageContainer'
import Footer from '../../components/Footer'
import { useTranslation } from 'react-i18next'

const EuDCC = () => {
    const handleScroll = () => {
        const targetElement = document.getElementById('download-whitepaper-form');
        if (targetElement) {
            const yOffset = 0;
            const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    const {t} = useTranslation()

    const items = [
        {
            id: 1,
            link: '/whitepapers/document-security',
            image: document_security_2023,
            chip: t("whitepapers-tab.document-security-whitepaper"),
            title: t('whitepapers.document-security-title'),
            content: t('whitepapers.document-security-content')
        },
        {
            id: 2,
            link: '/whitepapers/hr-document-security',
            image: hr_document,
            chip: t("whitepapers-tab.hr-document-security-whitepaper"),
            title: t('whitepapers.hr-document-security-title'),
            content: t('whitepapers.hr-document-security-content')
        },
        {
            id: 3,
            link: '/whitepapers/infographic-on-bank-fraud',
            image: info_graphic,
            chip: t("whitepapers-tab.banking-whitepaper"),
            title: t('whitepapers.info-graphic-title'),
            content: t('whitepapers.info-graphic-content')
        },
        

    ];

    return (
        <div className='eudcc bg-primary'>
            <div className='color-filter-right' style={{ top: "45%" }}>
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <div className='color-filter-left' style={{ top: "55%" }} >
                <img src={filter_color} alt="" className='img-responsive' />
            </div>

            <Navbar />
            <div className='container-fluid eudcc-header'>
                <div className='container pt-100 pt-md-150'>
                    <div className='col-sm-12 col-xl-7 px-md-0 pt-f768-t991-0'>
                        <p className='font-64 font-weight-semi-bold header-sub-title'>{t('whitepapers.eudcc.title')}</p>
                        <p className='font-60 font-weight-semi-bold header-title'>{t('whitepapers.download-whitepaper-for-free')}</p>
                        <p className='pt-30 text-white'>{t('whitepapers.eudcc.sub-title')}</p>
                        <div className='pt-30'>
                            <PrimaryButton onClick={handleScroll}>{t('button.download-whitepaper-for-free')}</PrimaryButton>
                        </div>
                    </div>
                    <div className='col-sm-12 col-xl-5 pt-50 pt-xl-0 px-xl-0'>
                        <div className='flex justify-center pt-xl-120' >
                            <img src={eudcc} alt="eudcc" className='img-responsive img-header' />
                            <div className='eudcc-behind-line'></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container pt-70'>
                <div className='look-inside col-sm-12'>
                    <div className='col-xl-5 pt-xl-40'>
                        <div className='flex justify-center'>
                            <img src={eudcc} alt="qr_code_1" className='img-responsive' />
                        </div>
                    </div>
                    <div className='col-xl-7'>
                        <p className='font-32 font-weight-semi-bold'>{t('whitepapers.looking-inside-the-whitepaper')}</p>
                        <p className='pt-20'>
                        {t('whitepapers.eudcc.content')}
                        </p>
                        <div className='pt-20'>
                            <PrimaryButton2th onClick={handleScroll}>{t('button.download-whitepaper-for-free')}</PrimaryButton2th>
                        </div>
                    </div>
                </div>
            </div>

            <WhitepaperDownloadForm />

            <OtherWhitepapers items={items} />


            <div className='container'>
                <IndustriesImageContainer />
            </div>
            <Footer />
        </div>
    )
}

export default EuDCC